export const api_path = process.env.REACT_APP_APOLLO_PATH;
export const express_path = process.env.REACT_APP_SERVER_PATH;

export const eventKey = process.env.REACT_APP_EVENT_KEY;

export const isAdmin = process.env.REACT_APP_MODE === 'ADMIN';
